<div class="vendorview-modal" id="addedit-vendor-modal-vendorview-modal">
  <app-addedit-vendor [data]="vendorData" id="addedit-vendor-modal-addedit-vendor"></app-addedit-vendor>
  <button (click)="closeVendorPopUpDialog()" mat-raised-button color="warn" class="pull-right close-button" id="addedit-vendor-modal-close-button">Close</button>
</div>
